import { render, staticRenderFns } from "./HomeContainerCards.vue?vue&type=template&id=2bd1ef08&scoped=true"
import script from "./HomeContainerCards.vue?vue&type=script&lang=js"
export * from "./HomeContainerCards.vue?vue&type=script&lang=js"
import style0 from "./HomeContainerCards.vue?vue&type=style&index=0&id=2bd1ef08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd1ef08",
  null
  
)

export default component.exports